import { gql } from "@apollo/client";
import { TypeDefinitionAttributeFields } from "../fragments/typeDefinitionAttribute";

export const InstalledBaseEventTDAs = gql`
    query InstalledBaseEventTDAs($eventId: ID!) {
        installedBaseEvent(eventId: $eventId) {
            id
            eventType
            # Only on InstalledBaseEvent - the query returns EventInterface (IBM-1062)
            ... on InstalledBaseEvent {
                typeDefinitionAttributeList {
                    typeDefinitionAttributes {
                        ...TypeDefinitionAttributeFields
                    }
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
